<app-header extraClass="nav-down text-gray-innerMenu" displayNavigation="true"></app-header>

<section class="live-matches-wrp">

    <div class="banners-img mt-6 position-relative">
        <div class="image">
            <img src="../assets/images/ipl/bg.jpg" alt="" class="w-100">
        </div>
        <a class="how-to-play" [routerLink]="['/'+appService.getCurrentCity()+'/play-deal-pe-deal']">HOW TO PLAY</a>
    </div>
    <!--banners-img end-->

    <div class="tab-wrp middle-panel hidelg m-0">

        <ul uk-tab class="swtitch-tab">
            <li class="uk-active"><a (click)="getMatches('live')">Live Matches</a></li>
            <li><a (click)="getMatches('past')">Past Matches</a></li>
        </ul>

        <ul class="uk-switcher mb-2">
            <li>
                <div class="accordion-wrp">

                    <mat-accordion class="transparent-accordion" *ngIf="matchType === 'live' && matches.length > 0">

                        <ng-container *ngFor="let match of matches; let i = index">
                            <div class="matches-timer position-relative mt-25">
                                <div class="image">
                                    <img src="{{match.match_image}}" alt="" class="w-100">
                                </div>

                                <div class="timer" *ngIf="matchType==='live'">
                                    <div class="countdown">
                                        <countdown [config]="{leftTime: match.timeleft}"></countdown>
                                    </div>
                                    <span>TIME LEFT</span>
                                </div>
                            </div>
                            <!--matches-timer end-->

                            <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        View Brand Predictions
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="panel-data">
                                    <app-live-matches-card *ngFor="let poll of match.question?.poll" [MatchType]="matchType" [data]="match.question" [pollObject]="poll" [IPL_ID]="match.id">
                                    </app-live-matches-card>
                                </div>
                                <!--panel-data end-->
                            </mat-expansion-panel>
                        </ng-container>


                    </mat-accordion>


                    <!--FAQ-->
                    <div class="faq-wrp mt-2">
                        <h4>FAQs</h4>
                        <div class="faq-accordion">
                            <mat-accordion>
                                <mat-expansion-panel [expanded]="stepfaq === 0" (opened)="setStepfaq(0)">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            What is Deal Pe Deal?
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>Things2do presents Deal pe Deal which is this cricketing season's most exciting predict and win game. To participate all you have to do is agree or disagree with predictions made by your favorite brands. If you
                                            get the prediction right, you win additional deals on existing deals by Things2do!
                                        </p>
                                    </div>
                                </mat-expansion-panel>
                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            How to Play and Win?
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>Participate in the Things2do Premier League Deal pe Deal in 3 easy steps.
                                        </p>
                                        <ul class="game-rules">
                                            <li><b>Step 1:</b> Create an account and register with Things2do
                                            </li>
                                            <li><b>Step 2:</b> Choose the match and Agree or disagree with brand predictions of the day.</li>
                                            <li><b>Step 3:</b> Win double deals on every correct prediction! A discount code will be shared that you can use to avail deal pe deal.
                                            </li>
                                        </ul>
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            Can I participate in multiple brand predictions for a match?
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>Yes you can participate in multiple matches at the same time. </p>
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            When and How will the winners be announced?

                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>You will receive an email notification after the match results have been declared. If your prediction was right, you get to avail the Deal pe Deal within the next 24 hours. If you guessed wrong, you can still get
                                            the original deal on the Things2do Website and play again with a new match, new brand and new deal the next day. </p>
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            What are prizes for the winners?
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>Winners of each match will be shared a promotional code to get additional discounts on the deal of the day from the brand they have chosen! That is how you get Deal pe Deal by Things2do.
                                        </p>
                                    </div>
                                </mat-expansion-panel>

                                <mat-expansion-panel>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            If I win, how and where to use the promotional code?

                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div class="panel-data">
                                        <p>If your prediction is right, you will be shared with a promotional code which is applicable for a deal of the day from the brand you selected. Select the deal, apply the promo code and place your order and avail
                                            your Deal Pe Deal.
                                        </p>
                                    </div>
                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>
                    </div>

                </div>
                <!--accordion-wrp end-->

            </li>
            <!--li end-->

            <li>
                <div class="accordion-wrp">

                    <mat-accordion class="transparent-accordion" *ngIf="matchType === 'past'">

                        <ng-container *ngFor="let match of matches; let i = index">
                            <div class="matches-timer position-relative mt-25">
                                <div class="image">
                                    <img src="{{match.match_image}}" alt="" class="w-100">
                                </div>

                                <div class="timer" *ngIf="matchType==='live'">
                                    <div class="countdown">
                                        <div class="uk-flex uk-flex-center uk-flex-middle" uk-countdown="date: 2022-04-010T09:08:58+00:00">
                                            <div>
                                                <div class="uk-countdown-number uk-countdown-days"></div>
                                            </div>
                                            <div class="uk-countdown-separator">:</div>
                                            <div>
                                                <div class="uk-countdown-number uk-countdown-hours"></div>
                                            </div>
                                            <div class="uk-countdown-separator">:</div>
                                            <div>
                                                <div class="uk-countdown-number uk-countdown-minutes"></div>
                                            </div>
                                            <div class="uk-countdown-separator">:</div>
                                            <div>
                                                <div class="uk-countdown-number uk-countdown-seconds"></div>
                                            </div>
                                        </div>
                                    </div>
                                    <span>TIME LEFT</span>
                                </div>
                            </div>
                            <!--matches-timer end-->

                            <mat-expansion-panel [expanded]="step === i" (opened)="setStep(i)">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        View Brand Predictions
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div class="panel-data">

                                    <div class="matches-card" *ngFor="let poll of match.question?.poll">
                                        <div class="flip-card-inner">
                                            <div class="card-back">
                                                <div class="card uk-flex">
                                                    <div class="brand-logo position-relative">
                                                        <a [routerLink]="['/'+appService.getCurrentCity()+'/deals/by/'+poll.merchant.slug]">
                                                            <div class="image">
                                                                <img src="{{poll.merchant.ipl_logo}}" class="w-100 fitimg">
                                                            </div>
                                                        </a>
                                                    </div>
                                                    <div class="info">
                                                        <p>{{poll.merchant_poll}}</p>
                                                        <div class="progress progress-agree">
                                                            <!-- <div [ngStyle]="{'width': poll.agree+'%'}" class="progress-bar">agree</div>
                                                            <div [ngStyle]="{'width': 100-poll.agree+'%'}" class="percentage">{{poll.agree}}%</div> -->
                                                            <div [ngStyle]="{'width': poll.agree+'%'}" class="progress-bar"></div>
                                                            <span class="review-text">Agree</span>
                                                            <span class="percentage">{{poll.agree}}%</span>
                                                        </div>
                                                        <!--progress end-->
                                                        <div class="progress mt-1 progress-disagree">
                                                            <!-- <div [ngStyle]="{'width': poll.disagree+'%'}" class="progress-bar">Disagree</div>
                                                            <div [ngStyle]="{'width': 100-poll.disagree+'%'}" class="percentage">{{poll.disagree}}%
                                                            </div> -->
                                                            <div [ngStyle]="{'width': poll.disagree+'%'}" class="progress-bar"></div>
                                                            <span class="review-text">Disagree</span>
                                                            <span class="percentage">{{poll.disagree}}%</span>
                                                        </div>
                                                        <!--progress end-->
                                                    </div>
                                                </div>

                                                <div class="card-footer greenbg" *ngIf="poll.status === 'Correct'">
                                                    <p>HURRAY! {{poll.merchant.merchant_name}} PREDICTED RIGHT <span><i
                            class="fa fa-check-circle-o"></i></span></p>
                                                </div>

                                                <div class="card-footer redbg" *ngIf="poll.status === 'Incorrect'">
                                                    <p>OOPS! {{poll.merchant.merchant_name}} PREDICTION WAS WRONG <span><i
                            class="fa fa-times-circle-o"></i></span></p>
                                                </div>

                                            </div>
                                            <!--card-back end-->
                                        </div>
                                    </div>

                                </div>
                                <!--panel-data end-->
                            </mat-expansion-panel>
                        </ng-container>


                    </mat-accordion>

                    <a (click)="loadMorePastMatches()" class="btn-more">View more</a>

                </div>
                <!--accordion-wrp end-->
            </li>
        </ul>

    </div>

</section>

<div class="footer-small-wrp">
    <p>Powered by Things2do</p>
    <a href="">Terms and conditions.</a>
</div>